/* eslint-disable */
import { userManagement } from '../api.js'

import cloneDeep from 'clone-deep'

import notifications from '../notifications.js'
import events from '../events.js'

import { isEmpty, isArray } from 'lodash'


const _vars = {
  users: undefined,
  queryErrors: undefined,
  pendingUsers: [],
  selectorModals: {},
  configData: {},
}

function _clearExistingUsers() {
  _vars.users = undefined
}

function _mapUserData(allUsers) {
  let remappedUserData = allUsers.map(user => {
    if (user['app_metadata'] === undefined) {
      user['app_metadata'] = {}
    }
    if (user['user_metadata'] === undefined) {
      user['user_metadata'] = {}
    }
    return user
  })

  if (_vars.users === undefined) {
    _vars.users = {}
  }

  _vars.users = remappedUserData.reduce(
    (accum, curr) => {
      accum[curr.user_id] = curr
      return accum
    },
    _vars.users
  )
}

function _mapUserGroupData(allUserGroups) {
  return allUserGroups.map(userGroup => {
    return userGroup.name
  })
}

function _mapQueryErrors(queryErrors) {
  let existingErrors = {}
  _vars.queryErrors = queryErrors.reduce(
    (accum, curr) => {
      if (existingErrors[curr.line + 1] === undefined) {
        existingErrors[curr.line + 1] = []
      }
      for (const errorStr of curr.errors) {
        if (existingErrors[curr.line + 1].indexOf(errorStr) < 0) {
          existingErrors[curr.line + 1].push(errorStr)

          if (accum[curr.line + 1] === undefined) {
            accum[curr.line + 1] = []
          }
          accum[curr.line + 1].push(errorStr)
        }
      }

      return accum
    },
    {}
  )
}

function _mapConfigData(data) {
  if (data.partition) {
    _vars.configData.partitions = {}
    for (const partitionData of data.partition) {
      _vars.configData.partitions[partitionData.id] = partitionData
    }
  }

  if (data.vendor) {
    _vars.configData.vendors = {}
    for (const vendorData of data.vendor) {
      let partitionId = vendorData.partition.id
      vendorData.partition = _vars.configData.partitions[partitionId]
      _vars.configData.vendors[vendorData.id] = vendorData
    }
  }

  if (data.district) {
    _vars.configData.districts = {}
    for (const districtData of data.district) {
      let partitionId = districtData.partition_id
      districtData.partition = _vars.configData.partitions[partitionId]
      _vars.configData.districts[districtData.id] = districtData
    }
  }

  if (data.student) {
    _vars.configData.students = {}
    for (const studentData of data.student) {
      _vars.configData.students[studentData.db_id] = studentData
    }
  }
}

function _markPendingUser(userId) {
  _vars.pendingUsers.push(userId)
}

function _matchPortalUsers(portalUserData) {
  let retMap = {}
  for (const portalUser of portalUserData) {
    if (_vars.users[portalUser.auth0_id]) {
      retMap[portalUser.auth0_id] = portalUser
    }
  }
  return retMap
  // return portalUserData.filter((portalUser) => _vars.users[portalUser.auth0_id]).reduce()
}

function _postNewOneTimeNoRideForm(content) {
  let promise = postNewOneTimeNoRideForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _statusManagementApiToken() {
  let promise = userManagement.statusManagementApiToken()
    .then((result) => {
      if (result.status > 299) {
        notifications.pushError('Error acquiring data from server.')
        throw new Error(result)
      }
      if (result.status === 200) {
        notifications.pushInfo('Management API Token valid')
        return 'Valid'
      }
      else if (result.status === 204) {
        notifications.pushError('Management API Token expired')
        return 'Expired'
      }
    })
    .catch(error => {
      notifications.pushError('Error acquiring data from server.', error)
    })

  return promise
}

function _refreshManagementApiToken() {
  let promise = userManagement.refreshManagementApiToken()
    .then((result) => {
      if (result.status !== 200) {
        notifications.pushError('Error refreshing management API token')
        throw new Error(result)
      }
      notifications.pushInfo(`Management API Token Updated on: ${result.data}`)
    })
    .catch(error => {
      notifications.pushError('Error acquiring data from server.', error)
    })

  return promise
}

function _getUsers(queryParams) {
  let promise = userManagement.getUsers(queryParams)
    .then((result) => {
      if (result.status !== 200) {
        notifications.pushError('Error acquiring user from server.')
        throw new Error(result)
      }
      _mapUserData(result.data.content)
      return result.data
    })
    .catch(error => {
      notifications.pushError('Error acquiring data from server.', error)
      throw new Error(error)
    })

  return promise
}

function _getUserGroups() {
  let promise = userManagement.getUserGroups()
    .then((result) => {
      if (result.status !== 200) {
        notifications.pushError('Error acquiring user groups from server.')
        throw new Error(result)
      }
      return _mapUserGroupData(result.data)
    })
    .catch(error => {
      notifications.pushError('Error acquiring data from server.', error)
      throw new Error(error)
    })

  return promise
}

function _getPortalUsers(auth0Ids) {
  let promise = userManagement.getPortalUsers({ ids: auth0Ids })
    .then((result) => {
      if (result.status !== 200) {
        notifications.pushError('Error acquiring data from server.')
        throw new Error(result)
      }
      return result.data
    })
    .catch(error => {
      notifications.pushError('Error acquiring data from server.', error)
      throw new Error(error)
    })

  return promise
}

function _batchManageUsersCommands(userData) {
  let promise = userManagement.batchManageUsersCommands(userData)
    .then((result) => {
      if (result.status !== 200) {
        notifications.pushError('Error acquiring data from server.')
        throw new Error(result)
      }
      _clearExistingUsers()
      notifications.pushInfo('Successfully updated users')
    })
    .catch(error => {
      console.error(error)
      if (error.response.status === 403) {
        notifications.pushError('Error: Forbidden')
        throw error
      }
      else if (error.response.status === 406) {
        _mapQueryErrors(error.response.data['errors'])
        notifications.pushError('Error(s) present in queries.')
        return _vars.queryErrors
      }
      notifications.pushError('Error acquiring data from server.', error)
      throw error
    })

  return promise
}

function _canViewAuth0Users(user) {
  if (user === undefined) {
    return false
  }

  return user.can('view_auth0_users')
}

function _canChangeAuth0Users(user) {
  if (user === undefined) {
    return false
  }

  return user.can('change_auth0_users')
}

function _createCreateUserQuery(name, email, groups, userConfig, appMetadata) {
  let first = true
  function addComma(retStr) {
    if (first) {
      first = false
      return retStr
    }
    else {
      return retStr += ','
    }
  }
  let retString = 'CREATE'
  if (name) {
    retString = addComma(retString) + ` name("${name.replaceAll('"', '\\"')}")`
  }
  if (email) {
    retString = addComma(retString) + ` email("${email.replaceAll('"', '\\"')}")`
  }
  if (groups && isArray(groups)) {
    for (const group of groups) {
      if (group === '') {
        continue
      }
      retString = addComma(retString) + ` group("${group.replaceAll('"', '\\"')}")`
    }
  }
  if (appMetadata != undefined && !isEmpty(appMetadata)) {
    retString = addComma(retString) + ` appmetadata(${JSON.stringify(appMetadata)})`
  }
  if (userConfig != undefined && !isEmpty(userConfig)) {
    retString = addComma(retString) + ` userconfig(${JSON.stringify(userConfig)})`
  }
  return retString
}

function _createEditUserQuery(userId, name, email, groups, userConfig, appMetadata) {
  let first = true
  function addComma(retStr) {
    if (first) {
      first = false
      return retStr
    }
    else {
      return retStr += ','
    }
  }
  let retString = 'UPDATE'
  if (userId) {
    retString = addComma(retString) + ` user(auth0_id="${userId.replaceAll('"', '\\"')}")`
  }
  if (name) {
    retString = addComma(retString) + ` name("${name.replaceAll('"', '\\"')}")`
  }
  if (email) {
    retString = addComma(retString) + ` email("${email.replaceAll('"', '\\"')}")`
  }
  if (groups && isArray(groups)) {
    for (const group of groups) {
      if (group === '') {
        continue
      }
      retString = addComma(retString) + ` group("${group.replaceAll('"', '\\"')}")`
    }
  }
  if (appMetadata != undefined && !isEmpty(appMetadata)) {
    retString = addComma(retString) + ` appmetadata(${JSON.stringify(appMetadata)})`
  }
  if (userConfig != undefined && !isEmpty(userConfig)) {
    retString = addComma(retString) + ` userconfig(${JSON.stringify(userConfig)})`
  }
  return retString
}

function _createDeleteUserQuery(userId) {
  let retString = `DELETE user(auth0_id="${userId.replaceAll('"', '\\"')}")`
  return retString
}

function _openSelectorModal(type, callback) {
  _vars.selectorModals[type].callback = callback
  events.trigger(`userManagement-${type}-open`)
}

function _closeSelectorModal(type, selectedData) {
  if (_vars.selectorModals[type].callback) {
    _vars.selectorModals[type].callback(selectedData)
  }
  events.trigger(`userManagement-${type}-close`)
}

function _registerSelectorModal(type, openCallback, closeCallback) {
  if (_vars.selectorModals[type] === undefined) {
    _vars.selectorModals[type] = {}
  }

  function _modalOpenCallback() {
    openCallback()
  }

  function _modalCloseCallback() {
    closeCallback()
  }

  _vars.selectorModals[type].open = events.register(`userManagement-${type}-open`, _modalOpenCallback)
  _vars.selectorModals[type].close = events.register(`userManagement-${type}-close`, _modalCloseCallback)
}

function _unregisterAllModals() {
  for (const type in _vars.selectorModals) {
    events.remove(`userManagement-${type}-open`, _vars.selectorModals[type].open)
    events.remove(`userManagement-${type}-close`, _vars.selectorModals[type].close)
  }
  _vars.selectorModals = {}
}

function _getConfigContent(typeArray, queryParams) {
  return userManagement.getConfigContent({ type: typeArray, ...queryParams })
    .then((result) => {
      if (result.status !== 200) {
        notifications.pushError('Error acquiring data from server.')
        throw new Error(result)
      }
      _mapConfigData(result.data)
      return cloneDeep(_vars.configData)
    })
    .catch(error => {
      notifications.pushError('Error acquiring data from server.', error)
      throw error
    })
}

function _init() {
  // do nothing
}

_init()

export default {
  markPendingUser: _markPendingUser,
  matchPortalUsers: _matchPortalUsers,
  statusManagementApiToken: _statusManagementApiToken,
  refreshManagementApiToken: _refreshManagementApiToken,
  getUsers: _getUsers,
  getUserGroups: _getUserGroups,
  getPortalUsers: _getPortalUsers,
  batchManageUsersCommands: _batchManageUsersCommands,
  canViewAuth0Users: _canViewAuth0Users,
  canChangeAuth0Users: _canChangeAuth0Users,
  createCreateUserQuery: _createCreateUserQuery,
  createEditUserQuery: _createEditUserQuery,
  createDeleteUserQuery: _createDeleteUserQuery,

  openSelectorModal: _openSelectorModal,
  closeSelectorModal: _closeSelectorModal,
  registerSelectorModal: _registerSelectorModal,
  unregisterAllModals: _unregisterAllModals,
  getConfigContent: _getConfigContent,
}
